import { Clock } from "lucide-react";

/**
 * "Expiring soon" pill badge — shown on offer cards when deal_expires_in <= 7 and deal_status === "active".
 * Red regardless of mode — urgency is universal.
 */
export default function ExpiringSoonBadge({ daysLeft }) {
  if (!daysLeft || daysLeft > 7 || daysLeft < 0) return null;

  const label = daysLeft <= 1 ? "Expires today" : `${daysLeft}d left`;

  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold bg-red-50 text-red-600 border border-red-200"
      data-testid="expiring-soon-badge"
    >
      <Clock className="w-2.5 h-2.5" />
      {label}
    </span>
  );
}
